import actions from './actions'

const initialState = {
  ledgerModalStatus: false,
}

export default function generalReducer(state = initialState, action) {
  switch (action.type) {
    case actions.SET_STATE:
      return { ...state, ...action.payload }
    default:
      return state
  }
}